import ScanWiseTable from './ScanWiseTable';

const ProcessScanWiseTable = (props) => {
	return <ScanWiseTable {...props} />;
};

export default ProcessScanWiseTable;
